import React from 'react'
import type { CSSProperties } from 'react'
import { isEmpty } from 'lodash-es'

import { TtProgressBar } from '@23/ui-react'

import { useWebinarColors } from '../../Designs/blocs/useWebinarColors'
import type { Poll } from '../model/Poll'

import './PollOptions.scss'

type PollOptionsProps = {
  poll: Poll
}

export const PollOptions = ({ poll }: PollOptionsProps) => {
  const { accent, sidebar } = useWebinarColors()

  const wasPollStarted = !isEmpty(poll.openedDate)

  const barStyle = {
    '--indicator-color': accent.color,
    '--track-color': sidebar.color,
    '--height': '8px',
  } as CSSProperties

  return (
    <div className="poll-options-component">
      {poll.options.map((option) => {
        const showAnswerCount =
          wasPollStarted && option.answerCount !== undefined

        return (
          <div key={option.id} className="option-wrapper">
            <div className="option-inner-body">
              <div className="poll-option-title-wrapper">
                <div className="title-wrapper">
                  {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
                  {`${option.option} ${showAnswerCount ? `(${option.answerCount})` : ''}`}
                </div>
                {option.answerPercentageFmt !== undefined && (
                  <div className="votes">{option.answerPercentageFmt}</div>
                )}
              </div>
              <div className="progress-wrapper">
                <TtProgressBar
                  percentage={Number(option.answerPercentage ?? 0) * 100}
                  style={barStyle}
                />
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
